import classNames from "classnames";
import { Bloodhound } from "extensions/bloodhound";
import debounce from "lodash-es/debounce";
import { createRef, Component } from "react";
import { faSearch } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-responsive-tabs/styles.css";

import { Placeholder } from "common/components/placeholder";

export class TypeAheadInput extends Component {
    static defaultProps = {
        showSearchIcon: true,
        selectedCategories: [],
        onePerCategory: false,
        focusOnMount: true,
        suggestion: { value: "", isDefault: false },
        readOnlyDimensions: new Set()
    };
    
    constructor(props) {
        super(props);
        this.state = {
            engineReady: false,
            inputVal: ""
        };
        this.textInput = createRef();
        this.engine = new Bloodhound({
            identify: (obj) => obj.id,
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace("typeahead", "alias"),
            local: props.srcData
        });
        this.initEngine = this.engine.initialize();
        
        this.searchDebounced = debounce((v) => this.search(v), 250);
    }
    
    componentDidMount() {
        this.initEngine.then(() => {
            this.setState({ engineReady: true }, () => {
                if (this.props.focusOnMount) {
                    this.setFocus();
                }
            });
        });
    }
    
    componentWillUnmount() {
        this.engine.clear();
        this.searchDebounced.cancel();
    }
    
    setFocus = () => {
        this.textInput?.current?.focus();
    };
    
    groupByCategory = (array) => array.reduce(
        (objectsByKeyValue, obj) => ({
            ...objectsByKeyValue,
            [obj.pivot_alias]: (objectsByKeyValue[obj.pivot_alias] || []).concat(obj)
        }),
        {}
    );
    
    search = (value) => {
        const isOmit = value.charAt(0) === "-";
        const val = isOmit ? value.substring(1) : value;
        if (val === "" && isOmit) {
            return;
        }
        this.engine.search(
            val,
            (results) => {
                if (this.props.onePerCategory && this.props.selectedCategories.length) {
                    // filter results to not show already selected category
                    results = results.filter((r) => !this.props.selectedCategories.includes(r.pivot));
                }
                results = results.filter((k) => !this.props.readOnlyDimensions.has(k.pivot));
                this.props.onTypeAhead({
                    raw: results, grouped: this.groupByCategory(results), value, isOmit
                });
            },
            (d) => { // remote async
                // console.log(d);
            }
        );
    };
    
    inputChanged = (e) => {
        const value = e.currentTarget.value;
        this.setState({ inputVal: value });
        this.searchDebounced(value);
    };
    
    inputKeyDown = (e) => {
        const code = e.keyCode;
        if ((code === 8 || code === 46) && this.state.inputVal === "" && this.props.onDelete) {
            this.props.onDelete();
        }
    };
    
    clearInput() {
        this.setState({ inputVal: "" });
    }
    
    render() {
        if (this.state.engineReady) {
            let sVal = "";
            let iVal = this.state.inputVal;
            if (this.props.suggestion.value) {
                if (this.props.suggestion.isDefault) {
                    if (this.props.suggestion.value.slice(0, this.state.inputVal.length).toLowerCase() === this.state.inputVal.toLowerCase()) {
                        sVal = `${this.state.inputVal}${this.props.suggestion.value.slice(this.state.inputVal.length, this.props.suggestion.value.length)}`;
                    } else {
                        sVal = this.state.inputVal;
                    }
                } else {
                    iVal = this.props.suggestion.value;
                }
            }
           
            if (this.props.showSearchIcon) {
                return (
                    <div className={classNames("typeahead-wrapper", { "type-ahead-icon": this.props.showSearchIcon })}>
                        <FontAwesomeIcon className="icon" icon={faSearch} />
                        <div className="suggestion">{sVal}</div>
                        <input type="text" ref={this.textInput} width="200" className="tt-input" placeholder="Search" onKeyDown={this.inputKeyDown} onChange={this.inputChanged} value={iVal}/>
                    </div>
                );
            }
            return (
                <div className={classNames("typeahead-wrapper", { "type-ahead-icon": this.props.showSearchIcon })}>
                    <div className="suggestion">{sVal}</div>
                    <input type="text" ref={this.textInput} width="200" className="tt-input" placeholder="Add a filter" onKeyDown={this.inputKeyDown} onChange={this.inputChanged} onFocus={this.checkForSuggestionValue} onBlur={this.props.onBlur} value={iVal}/>
                </div>
            );
        }
        return (<div><Placeholder size="medium"/></div>);
    }
}
